import React from 'react';
import { motion } from 'framer-motion';
type Mode = 'onboarding' | 'offboarding';
interface ModeSwitchProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
}
const MODES: {
  value: Mode;
  label: string;
}[] = [{
  value: 'onboarding',
  label: 'Onboarding'
}, {
  value: 'offboarding',
  label: 'Offboarding'
}];
export function ModeSwitch({
  mode,
  setMode
}: ModeSwitchProps) {
  return <div role="tablist" aria-label="Console mode" className="inline-flex rounded-lg border border-gray-200 bg-white p-1 shadow-sm" data-id="element-22" data-mp="1krfmba85zmrw">
      {MODES.map(m => {
      const active = mode === m.value;
      return <motion.button key={m.value} layoutId={`${m.value}-toggle`} type="button" role="tab" aria-selected={active} onClick={() => setMode(m.value)} className={`rounded-md px-4 py-1.5 text-xs font-semibold transition-colors duration-150 ${active ? 'bg-navy-600 text-white' : 'text-gray-500 hover:text-gray-800'}`} data-id="element-23" data-mp="1bppx8b1r8zxa">
            {m.label}
          </motion.button>;
    })}
    </div>;
}